import { Icon } from 'assets/index'
import { MainContainer, Header, SevenColonGrid } from './DataPickerStyles'
import { weekDayNames, generateDates } from './utils'
import Days from './Days'

interface DateRange {
  startDate: Date | null
  endDate: Date | null
}

interface DataPickerProps {
  dateRange: DateRange
  setDateRange: React.Dispatch<React.SetStateAction<DateRange>>
  showDataPicker: boolean
  setCurrentMonth: (value: number) => void
  setCurrentYear: (value: number) => void
  currentMonth: number
  currentYear: number
}

function DataPicker({
  dateRange,
  setDateRange,
  showDataPicker,
  setCurrentMonth,
  setCurrentYear,
  currentMonth,
  currentYear,
}: DataPickerProps) {
  const nextMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0)
      setCurrentYear(currentYear + 1)
    } else {
      setCurrentMonth(currentMonth + 1)
    }
  }
  const prevMonth = () => {
    if (currentMonth > 0) {
      setCurrentMonth(currentMonth - 1)
    } else {
      setCurrentYear(currentYear - 1)
      setCurrentMonth(11)
    }
  }

  return (
    <MainContainer $showDataPicker={showDataPicker}>
      <div className="month-container">
        <Header>
          <button onClick={prevMonth} type="button" className="month-btn">
            <img src={Icon('chevron_left.svg')} alt="icon" />
          </button>

          <div className="select-container">
            <span className="select-data-picker">
              {new Date(currentYear, currentMonth).toLocaleString('pt-BR', {
                month: 'long',
              })}
            </span>
            <span className="select-data-picker">{currentYear}</span>
          </div>

          <button onClick={nextMonth} type="button" className="month-btn">
            <img src={Icon('chevron_right.svg')} alt="icon" />
          </button>
        </Header>

        <SevenColonGrid>
          {weekDayNames.map((day, i) => (
            <span key={`day${i}`} className="week-days">
              {day}
            </span>
          ))}
        </SevenColonGrid>

        <SevenColonGrid>
          {generateDates(currentMonth, currentYear).map(
            ({ date, isOnCurrentMonth }) => {
              return (
                <Days
                  fullDate={date}
                  isOnCurrentMonth={isOnCurrentMonth}
                  key={`${date}`}
                  dateRange={dateRange}
                  setDateRange={setDateRange}
                />
              )
            }
          )}
        </SevenColonGrid>
      </div>
    </MainContainer>
  )
}

export default DataPicker
